export default {
    key: 'adventure',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: false,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    activityId: undefined,
    categoryId: '9fa52b82-8d5b-4af1-9d20-6d2f3b271872',
    defaultDuration: undefined,
    isMultiDay: false,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: false,
    isPromotionRequired: false,
    showDuration: true,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: undefined,
    contentfulId: 'adventure',
    steps: [],

} satisfies ProductConfigActivity;
